import React, { useState } from 'react'
import { Button, ListGroup, ListGroupItem, Modal, ModalBody, ModalHeader, Form, Row, Col, Label, Input, Spinner } from 'reactstrap'
import { addNewPointAPI, deleteCertificationPointAPI, editCertificationPointAPI, getSingleCertificateAPI } from '../../../apiConfig/apiCall';
import Select from "react-select";
import { toast } from 'react-toastify';
import useReactSelectCustomStyle from '../../../hooks/useReactSelectCustomStyle';
import { useDispatch } from 'react-redux';
import { getCertificationList } from '../../../slices/ManageCompliance/thunk';
import ExportCSVModal from '../../../Components/Common/ExportCSVModal';
import Swal from 'sweetalert2';

export default function FrameworkPointsModal({
    frameworkPointsModal,
    toggleframeworkPointsModal,
    frameworkType,
    frameworkVersion,
    frameworkPoints,
    setframeworkPoints,
    cvId,
}) {

    const [submittingForm, setSubmittingForm] = useState(false);


    const dispatch = useDispatch();
    const selectBoxCustomStyles = useReactSelectCustomStyle();

    const [editCertificateModal, setEditCertificateModal] = useState(false);

    const statusOptions = [
        { value: 'ACTIVE', label: 'ACTIVE' },
        { value: 'INACTIVE', label: 'INACTIVE' },
    ];

    const [addNewPointModal, setAddNewPointModal] = useState(false);
    const toggleAddNewPointModal = () => {
        handleReset();
        setAddNewPointModal(!addNewPointModal)
    };

    const [editframeworkPointsModal, setEditframeworkPointsModal] = useState(false);
    const toggleEditframeworkPointsModal = () => setEditframeworkPointsModal(!editframeworkPointsModal);

    const [editCertificationPointFormData, setEditCertificationPointFormData] = useState({
        certificationIndex: "",
        status: null,
        controlWording: ""
    });

    const handleChangeEditCertificationPoint = (field, value) => {
        setEditCertificationPointFormData((prevState) => ({
            ...prevState,
            [field]: value
        }));
    };

    const [cvp_id, setCvp_id] = useState();
    const handleEditCertificationPoint = async (data, id) => {
        setCvp_id(id);
        setEditframeworkPointsModal(true);
        setFormDataPoint({
            certificationIndex: data.certificationIndex || '',
            status: data.status || null,
            controlWording: data.controlWording || ''
        });
    }

    const handleEditframeworkPointsubmit = async (e) => {
        try {
            e.preventDefault();

            const { certificationIndex, status, controlWording } = formDataPoint;

            if (submittingForm) return;

            if (!certificationIndex) {
                toast.error('Certification Index is required');
                return;
            } else if (certificationIndex.length > 10) {
                toast.error('Certification Index must be a maximum of 10 characters');
                return;
            }

            if (status === null || status === '') {
                toast.error('Status is required');
                return;
            }

            if (!controlWording) {
                toast.error('Control Wording is required');
                return;
            } else if (controlWording.length > 2000) {
                toast.error('Control Wording must be a maximum of 2000 characters');
                return;
            }

            const payload = {
                cvpId: cvp_id,
                status,
                certificationIndex,
                controlWording
            };
            setSubmittingForm(true);

            const apiResponse = await editCertificationPointAPI(payload);
            if (apiResponse.status === 200) {
                toast.success(apiResponse.data);
                setEditCertificateModal(false);
                dispatch(getCertificationList());
            }
            else if (apiResponse.status === 400) {
                toast.error(apiResponse.data);
            }
            else {
                toast.error("Something went wrong");
            }
        } catch (error) {
            console.log(error.message);
        }
    }

    // Add New Point
    const initialFormData = {
        certificationIndex: "",
        status: null,
        controlWording: "",
    }
    const [formDataPoint, setFormDataPoint] = useState(initialFormData);

    const pointStatusOption = [
        { value: "YES", label: "YES" },
        { value: "NO", label: "NO" },
    ];

    // const handleInputChange = (field, value) => {
    //     setFormDataPoint((prevState) => ({
    //         ...prevState,
    //         [field]: value,
    //     }));
    // };

    const handleInputChange = (field, value) => {
        const maxLengthControlWording = 2000;
        const maxLengthStandard = 10;

        if (field === 'controlWording') {
            if (value.length <= maxLengthControlWording) {
                setFormDataPoint((prevState) => ({
                    ...prevState,
                    [field]: value,
                }));
            } else {
                toast.error(`Maximum character limit reached for controlWording (${maxLengthControlWording})`);
            }
        } else if (field === 'certificationIndex' || field === 'status') {
            if (value.length <= maxLengthStandard) {
                setFormDataPoint((prevState) => ({
                    ...prevState,
                    [field]: value,
                }));
            } else {
                toast.error(`Maximum character limit reached for ${field} (${maxLengthStandard})`);
            }
        } else {
            setFormDataPoint((prevState) => ({
                ...prevState,
                [field]: value,
            }));
        }
    };

    const handleReset = () => {
        setFormDataPoint(initialFormData);
    };

    const submitAddNewPoint = async (e) => {
        e.preventDefault();

        try {
            const { certificationIndex, status, controlWording } = formDataPoint;

            if (submittingForm) return;

            if (!certificationIndex) {
                toast.error('Certification Index is required');
                return;
            } else if (certificationIndex.length > 10) {
                toast.error('Certification Index must be a maximum of 10 characters');
                return;
            }

            if (status === null || status === '') {
                toast.error('Status is required');
                return;
            }

            if (!controlWording) {
                toast.error('Control Wording is required');
                return;
            } else if (controlWording.length > 2000) {
                toast.error('Control Wording must be a maximum of 2000 characters');
                return;
            }

            const payload = {
                cvId,
                status,
                certificationIndex,
                controlWording
            };
            setSubmittingForm(true); // Set submittingForm to true before making the API call
            const apiResponse = await addNewPointAPI(payload);
            if (apiResponse.status === 200) {
                toast.success(apiResponse.data);
                setAddNewPointModal(false);
                dispatch(getCertificationList());
            }
            else if (apiResponse.status === 400) {
                toast.error(apiResponse.data);
            }
        } catch (error) {
            console.error('Error sending data:', error);
            toast.error('An error occurred while adding the certification point');
        } finally {
            setSubmittingForm(false);
        }
    };

    const [isExportCSV, setIsExportCSV] = useState(false);

    // const handleDeleteCertificationPoint = (id) => {
    //     Swal.fire({
    //         width: '20rem',
    //         padding: '0 0 1rem 0',
    //         title: "Are you sure?",
    //         text: `You won't be able to revert this!`,
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#3085d6",
    //         cancelButtonColor: "#d33",
    //         confirmButtonText: "Yes, delete it!"
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             deleteCertificationPointAPI(id)
    //                 .then(response => {
    //                     Swal.fire({
    //                         title: "Deleted!",
    //                         text: response.data,
    //                         icon: "success",
    //                         width: '20rem',
    //                         padding: '0 0 1rem 0',
    //                     });
    //                 })
    //                 .catch(error => {
    //                     Swal.fire({
    //                         title: "Error!",
    //                         text: error,
    //                         icon: "error",
    //                         width: '20rem',
    //                         padding: '0 0 1rem 0',
    //                     });
    //                 });
    //         }
    //     });
    // };

    const handleDeleteCertificationPoint = (pointId) => {
        Swal.fire({
            width: '20rem',
            padding: '0 0 1rem 0',
            title: "Are you sure?",
            text: `You won't be able to revert this!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                deleteCertificationPointAPI(pointId)
                    .then((response) => {
                        Swal.fire({
                            title: "Deleted!",
                            text: response.data,
                            icon: "success",
                            width: '20rem',
                            padding: '0 0 1rem 0',
                        });
                        // Refresh certification points
                        getSingleCertificateAPI(cvId).then((apiResponse) => {
                            if (apiResponse.status === 200) {
                                setframeworkPoints(apiResponse.data.frameworkVersionPoints);
                            }
                        });
                    })
                    .catch((error) => {
                        Swal.fire({
                            title: "Error!",
                            text: error.message,
                            icon: "error",
                            width: '20rem',
                            padding: '0 0 1rem 0',
                        });
                    });
            }
        });
    };

    return (
        <>

            <ExportCSVModal
                show={isExportCSV}
                onCloseClick={() => setIsExportCSV(false)}
                data={frameworkPoints}
            />
            <Modal isOpen={frameworkPointsModal} toggle={toggleframeworkPointsModal} fullscreen>
                <ModalHeader toggle={toggleframeworkPointsModal} tag={'h4'} className='py-2'>Framework Points {frameworkType} - {frameworkVersion}
                    <Button type="button" color='primary' className="btn-sm mx-2" onClick={() => setIsExportCSV(true)}>
                        <i className="ri-file-download-line align-bottom me-1"></i>{" "}
                        Export
                    </Button>

                    <Button type="button" color='secondary' className="btn-sm mx-2" onClick={toggleAddNewPointModal}>
                        <i className="ri-file-download-line align-bottom me-1"></i>{" "}
                        Add New Point
                    </Button>

                </ModalHeader>
                <ModalBody>
                    {
                        frameworkPoints && frameworkPoints.length > 0 ? (
                            frameworkPoints.map((data, index) => (
                                <div key={index} className='mb-3'>
                                    <ListGroup className="mb-0" horizontal>
                                        <ListGroupItem className='fs-5 py-1 px-2' style={{ width: '5rem' }}>
                                            {data.certificationIndex}
                                        </ListGroupItem>
                                        <ListGroupItem className='fs-5 py-1 px-2' style={{ width: '5rem' }}>
                                            <i className="ri-delete-bin-5-line align-middle me-2 cursor-pointer"
                                                onClick={() => handleDeleteCertificationPoint(data.id)}>
                                            </i>
                                            <i className='bx bxs-edit align-middle me-2 cursor-pointer'
                                                onClick={() => handleEditCertificationPoint(data, data.id)}>
                                            </i>
                                        </ListGroupItem>
                                        <ListGroupItem className='fs-5 py-1 px-2' style={{ width: '90rem' }}>
                                            {data.description}
                                        </ListGroupItem>
                                    </ListGroup>
                                </div>
                            ))
                        ) : (
                            <h4 className="mt-3">No data available</h4>
                        )
                    }
                </ModalBody>
            </Modal>

            <Modal isOpen={addNewPointModal} toggle={toggleAddNewPointModal}>
                <ModalHeader toggle={toggleAddNewPointModal}>
                    Add New Point
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <Row className="gy-3">
                            <Col lg={6}>
                                <div>
                                    <Label htmlFor="certificationIndex" className="form-label">Index</Label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        id="certificationIndex"
                                        value={formDataPoint.certificationIndex}
                                        onChange={(e) => handleInputChange('certificationIndex', e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div>
                                    <Label htmlFor="status" className="form-label">Mapped</Label>
                                    <Select
                                        value={formDataPoint.status ? pointStatusOption.find(option => option.value === formDataPoint.status) : null}
                                        onChange={(option) => handleInputChange('status', option?.value || null)}
                                        options={pointStatusOption}
                                        styles={selectBoxCustomStyles}
                                    />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div>
                                    <Label htmlFor="controlWording" className="form-label">Wording</Label>
                                    <Input
                                        type="textarea"
                                        className="form-control"
                                        id="controlWording"
                                        value={formDataPoint.controlWording}
                                        onChange={(e) => handleInputChange('controlWording', e.target.value)}
                                        style={{ height: "200px" }}
                                    />
                                </div>
                            </Col>
                            <Col lg={12}>
                                {
                                    submittingForm ? <Button color="primary" className="me-2" type='button' disabled>
                                        <Spinner size="sm"> Loading... </Spinner> </Button> : <Button color="primary" type="submit" className="me-2" disabled={submittingForm} onClick={submitAddNewPoint}> Add  </Button>
                                }
                                <Button color="secondary" type="reset" disabled={submittingForm} onClick={handleReset}> Reset </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>

            <Modal isOpen={editframeworkPointsModal} toggle={toggleEditframeworkPointsModal}>
                <ModalHeader toggle={toggleEditframeworkPointsModal}>Edit Framework Point</ModalHeader>
                <ModalBody>
                    <Form>
                        <Row className="gy-3">
                            <Col lg={6}>
                                <div>
                                    <Label htmlFor="certificationIndex" className="form-label">Index</Label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        id="certificationIndex"
                                        value={formDataPoint.certificationIndex}
                                        onChange={(e) => handleInputChange('certificationIndex', e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div>
                                    <Label htmlFor="status" className="form-label">Mapped</Label>
                                    <Select
                                        value={formDataPoint.status ? pointStatusOption.find(option => option.value === formDataPoint.status) : null}
                                        onChange={(option) => handleInputChange('status', option?.value || null)}
                                        options={pointStatusOption}
                                        styles={selectBoxCustomStyles}
                                    />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div>
                                    <Label htmlFor="controlWording" className="form-label">Wording</Label>
                                    <Input
                                        type="textarea"
                                        className="form-control"
                                        id="controlWording"
                                        value={formDataPoint.controlWording}
                                        onChange={(e) => handleInputChange('controlWording', e.target.value)}
                                        style={{ height: "200px" }}
                                    />
                                </div>
                            </Col>
                            <Col lg={12}>
                                {
                                    submittingForm ? <Button color="primary" className="me-2" type='button' disabled>
                                        <Spinner size="sm"> Loading... </Spinner> </Button> : <Button color="primary" type="submit" className="me-2" disabled={submittingForm} onClick={handleEditframeworkPointsubmit}> Update  </Button>
                                }
                                <Button color="secondary" type="reset" disabled={submittingForm} onClick={handleReset}> Reset </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    )
}
